<script>
  export default {
    name: 'policies-card',
    data: () => ({
      // finances: ['Financial Statements', 'Operating Budget'],
      budget: [
        { url: 'https://media.eipl.org/documents/budget/Early Mail Ballot Application EN ES.pdf', text: 'Early Mail Ballot Application (english & spanish)' },
        { url: 'https://media.eipl.org/documents/budget/Military Ballot Application EN ES.pdf', text: 'Military Ballot Application (english & spanish)' },
        { url: 'https://media.eipl.org/documents/finance/OpBudget_2025-2026.pdf', text: 'Proposed Budget 2025-2026' }
      ],
      finances: [
        { url: 'https://media.eipl.org/documents/finance/EIPL_financial_statement_24.pdf', text: 'Financial Statements' },
        { url: 'https://media.eipl.org/documents/finance/OpBudget_2024-2025.pdf', text: 'Operating Budget 2024-2025' }
      ],
      policies: [
        { text: 'Annual Report to the Community' },
        // { url: 'https://media.eipl.org/documents/policies/eisp_2019_year_in_review_infographic.pdf', text: 'Annual Report, the Year-in-Review East Islip Public Library 2019' },
        { url: 'https://media.eipl.org/documents/policies/Board%20Meeting%20Procedure.pdf', text: 'Board Meeting Procedures Policy' },
        { url: 'https://media.eipl.org/documents/policies/borrowing_rules.pdf', text: 'Borrowing Rules' },
        { url: 'https://media.eipl.org/documents/policies/by_laws.pdf', text: 'By-Laws' },
        { url: 'https://media.eipl.org/documents/policies/Circulation_of_Materials_Policy.pdf', text: 'Circulation of Materials Policy' },
        { url: 'https://media.eipl.org/documents/policies/Code%20of%20Ethics.pdf', text: 'Code of Ethics Policy' },
        { url: 'https://media.eipl.org/documents/policies/Computer_Security_Backup.pdf', text: 'Computer Security Policy' },
        { url: 'https://media.eipl.org/documents/policies/library_records_confidentiality_policy.pdf', text: 'Confidentiality of Library Records Policy' },
        { url: 'https://media.eipl.org/documents/policies/Conflict%20of%20Interest%20Policy.pdf', text: 'Conflict of Interest Policy' },
        { url: 'https://media.eipl.org/documents/policies/InternetSafetyPolicy.pdf', text: 'Internet Safety Policy' },
        { url: 'https://media.eipl.org/documents/policies/InternetPolicy.doc', text: 'Internet Use Policy' },
        { url: 'https://media.eipl.org/documents/policies/InvestmentPolicy.pdf', text: 'Investment Policy' },
        { url: 'https://media.eipl.org/documents/policies/Long-Range_Plan_21-26.pdf', text: 'Long Range Plan for the East Islip Public Library 2021-2026' },
        { url: 'https://media.eipl.org/documents/policies/Maker_Lab.pdf', text: 'Maker Lab Policy' },
        { url: 'https://media.eipl.org/documents/policies/Material_Selection_Policy_complete.pdf', text: 'Material Selection Policy' },
        { url: 'https://media.eipl.org/documents/policies/Meeting%20Room%20Policy_revised%20(3).pdf', text: 'Meeting Room Policy' },
        { url: 'https://media.eipl.org/documents/policies/PatronBeaviorPolicy.docx', text: 'Patron Behavior Policy' },
        { url: 'https://media.eipl.org/documents/policies/PublicAccess_computeruse.pdf', text: 'Public Access and Computer Use Policy' },
        { url: 'https://media.eipl.org/documents/policies/purchasing_procurement_pettycash.pdf', text: 'Purchasing, Procurement and Petty Cash Policy' },
        { url: 'https://media.eipl.org/documents/policies/SexualHarassmentPreventionPolicy.pdf', text: 'Sexual Harassment Prevention Policy' },
        { url: 'https://media.eipl.org/documents/policies/SexualHarassmentComplaintForm.pdf', text: 'Sexual Harassment Complaint Form' },
        { url: 'https://media.eipl.org/documents/policies/Tutor%20Policy.pdf', text: 'Tutor Policy' },
        { url: 'https://media.eipl.org/documents/policies/Whistleblower.pdf', text: 'Whistle Blower Policy' },
        { url: 'https://media.eipl.org/documents/policies/Workplace_Violence_and_Hostility_Policy.pdf', text: 'Workplace Hostility and Violence Policy' }
      ],
      tab: 2,
      today: null
    }),
    computed: {},
    methods: {},
    created() {
      this.today = new Date().toLocaleDateString(undefined, { weekday: 'long' })
    }
  }
</script>

<template>
  <v-card max-width="700" width="100%" class="mt-16">
    <v-app-bar color="primary" dark>
      <v-toolbar-title class="text-h5 font-weight-bold">Documents and Policies</v-toolbar-title>
      <template v-slot:extension>
        <v-tabs v-model="tab">
          <v-tabs-slider color="secondary"></v-tabs-slider>

          <v-tab key="budget"> Budget Vote </v-tab>
          <v-tab key="finance"> Finance </v-tab>
          <v-tab key="policies"> Policies </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
    <v-card-text class="card-text primary--text font-weight-bold">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-list>
            <template v-for="(finance, k) in budget">
              <v-list-item :key="k" class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="primary--text text-body-1 font-weight-bold">{{ finance.text }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="mr-0">
                  <v-btn color="primary" icon :href="finance.url" target="_blank"> <v-icon>mdi-open-in-new</v-icon> </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="k + 'd'"></v-divider>
            </template>
          </v-list>
        </v-tab-item>
        <v-tab-item>
          <v-list>
            <template v-for="(finance, k) in finances">
              <v-list-item :key="k" class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="primary--text text-body-1 font-weight-bold">{{ finance.text }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="mr-0">
                  <v-btn color="primary" icon :href="finance.url" target="_blank"> <v-icon>mdi-open-in-new</v-icon> </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="k + 'd'"></v-divider>
            </template>
          </v-list>
        </v-tab-item>
        <v-tab-item>
          <v-list>
            <template v-for="(policy, k) in policies">
              <v-list-item :key="k" class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="primary--text text-body-1 font-weight-bold">{{ policy.text }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="mr-0">
                  <v-btn color="primary" icon :href="policy.url" target="_blank"> <v-icon>mdi-open-in-new</v-icon> </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="k + 'd'"></v-divider>
            </template>
          </v-list>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<style scoped>
  .card-text {
    height: 520px;
    overflow-y: auto;
  }

  >>> .v-list-item__title {
    white-space: wrap;
    word-break: word;
  }
</style>
